import { Arrow } from "../atoms/Arrow";
import { Eyebrow } from "../atoms/Eyebrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";

type FinalCTAProps = { t: Copy };

export function FinalCTA({ t }: FinalCTAProps) {
  return (
    <section id="contact" className="section final-cta">
      <div className="container">
        <div className="fc-wrap">
          <Reveal>
            <Eyebrow className="on-dark">{t.finalcta.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h2" className="fc-title" delay={60}>
            <span className="ink-inv">{t.finalcta.title_a} </span>
            <span className="ink-inv dim">{t.finalcta.title_b} </span>
            <span className="serif-accent accent-blue">{t.finalcta.title_c}</span>
          </Reveal>
          <Reveal as="p" className="fc-sub" delay={120}>
            {t.finalcta.sub}
          </Reveal>
          <Reveal className="fc-ctas" delay={180}>
            <a href="#" className="btn btn-primary btn-lg">
              {t.finalcta.cta} <Arrow />
            </a>
            <a
              href={"mailto:" + t.finalcta.cta2}
              className="btn btn-ghost btn-lg on-dark"
            >
              {t.finalcta.cta2}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
